import Popup from './Popup'

export type { PopupProps } from './Popup'
export default Popup
